import { useEffect, useState } from "react";
import { getMe } from "../api/auth";

export function Settings() {
  const [me, setMe] = useState<{ id: string; email: string; created_at: number } | null>(null);
  useEffect(() => {
    getMe()
      .then(setMe)
      .catch(() => setMe(null));
  }, []);
  if (!me) return <div className="page">Loading…</div>;
  return (
    <div className="page">
      <h1>Settings</h1>
      <div className="list-card">
        <h3>Account</h3>
        <p>
          <strong>Email:</strong> {me.email}
        </p>
        <p>
          <strong>User ID:</strong> {me.id}
        </p>
        <p>
          <strong>Member since:</strong>{" "}
          {new Date(me.created_at * 1000).toLocaleDateString()}
        </p>
      </div>
    </div>
  );
}
